<template>
<div>
    <div>     
        <font style="color: red;" v-if="tb.ismust">*</font>
         <font style="color: red;" v-else="tb.ismust">&nbsp </font>
         {{tb.name}}</div>
         <div>
            <van-rate v-model="value" 
            :size="25"
            color="#ffd21e"
            void-icon="star"
            :count="10"
            void-color="#eee"/>
         </div>

</div>
</template>


<script>
import Vue from 'vue';
import { Rate } from 'vant';

Vue.use(Rate);
export default{
    props:['tb'],
    data(){
        return{
            value: 0,
        }
    },
    watch:{
        value(n,o){
  
            this.tb.val = n;
            
        }
    }

}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/fields/Star.vue